export default "__VITE_ASSET__dcdb74eb__"